// LoginPage.tsx
import { useState } from "react";
import { useLogin, useNotify, useTranslate } from "react-admin";
import {
  TextField,
  Button,
  Typography,
  Box,
  Link as MuiLink,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import useStyles from "./style";
import { usePageTitle } from "@/utilities";
import PasswordField from "@/components/passwordfield/PasswordField";

const LoginPage = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const login = useLogin();
  const translate = useTranslate();
  const notify = useNotify();
  const [credentials, setCredentials] = useState({
    username: "",
    password: "",
  });

  usePageTitle("Connexion");

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    try {
      await login(credentials, "/");
    } catch {
      notify("Invalid username or password", { type: "warning" });
    }
  };

  return (
    <div className={classes.root}>
      <div className={classes.leftPane}>
        <Box
          component="img"
          src="/logo-gameoo.png"
          alt="GAMEOO"
          className={classes.brand}
        />

        {/* Centered form */}
        <div className={classes.formWrap}>
          <div className={classes.form}>
            <Typography variant="h4" className={classes.title}>
              {translate("ra.gameoo.signIn.formTitle")}
            </Typography>
            <form onSubmit={handleSubmit}>
              <TextField
                className={classes.input}
                label="Pseudo"
                variant="outlined"
                fullWidth
                onChange={(e) =>
                  setCredentials({ ...credentials, username: e.target.value })
                }
                sx={{ mb: 2 }}
              />
              <PasswordField
                className={classes.input}
                label={translate("ra.gameoo.register.passwordLabel")}
                variant="outlined"
                fullWidth
                onChange={(e) =>
                  setCredentials({ ...credentials, password: e.target.value })
                }
                sx={{ mb: 2 }}
              />
              <Button
                className={classes.buttonLogIn}
                type="submit"
                variant="contained"
              >
                {translate("ra.gameoo.signIn.btnConnect")}
              </Button>
              <Typography className={classes.sectionSignUp}>
                {translate("ra.gameoo.signIn.noAccount")}{" "}
                <MuiLink
                  component="button"
                  type="button"
                  onClick={() => navigate("/register")}
                >
                  {translate("ra.gameoo.signUpLabel")}
                </MuiLink>
              </Typography>
              <Typography className={classes.sectionForgotPassword}>
                <MuiLink
                  component="button"
                  type="button"
                  onClick={() => navigate("/forgot-password")}
                >
                  {translate("ra.gameoo.signIn.lnkForgotPassword")}
                </MuiLink>
              </Typography>
            </form>
          </div>
        </div>
      </div>
      <div className={classes.rightPane} aria-hidden />
    </div>
  );
};

export default LoginPage;
